import gql from "graphql-tag";

const costCenterMutations = {


    createCostCenter: gql`
        mutation CreateCostCenter($number: String, $name: String, $color: String, $closed: Boolean) {
            createCostCenter(number: $number, name: $name, color: $color, closed: $closed) {
                id,
                number,
                name,
                color,
                closed
            }
        }
    `,
    updateCostCenter: gql`
        mutation UpdateCostCenter($id: ID!, $number: String, $name: String, $color: String, $closed: Boolean) {
            updateCostCenter(id: $id, number: $number, name: $name, color: $color, closed: $closed) {
                id,
                number,
                name,
                color,
                closed
            }
        }
    `,
};

export default costCenterMutations;